export interface FilterOption {
    key: string;
    value: string;
}

export const educationOptions: FilterOption[] = [
    { key: '', value: 'Any' },
    { key: JSON.stringify({ qualification_name: 'CDA', value: 'true' }), value: 'CDA' },
    {
        key: JSON.stringify({ qualification_name: 'Education', option_value: "Associate's Degree" }),
        value: "Associate's Degree",
    },
    {
        key: JSON.stringify({ qualification_name: 'Education', option_value: "Bachelor's Degree" }),
        value: "Bachelor's Degree",
    },
];

export const experienceOptions: FilterOption[] = [
    { key: '', value: 'Any' },
    { key: JSON.stringify({ qualification_name: 'Years Experience', value: '0' }), value: '0-1 years' },
    { key: JSON.stringify({ qualification_name: 'Years Experience', value: '1' }), value: '1-5 years' },
    { key: JSON.stringify({ qualification_name: 'Years Experience', value: '5' }), value: '5+ years' },
];
